/** Retry schedule — SPEC §12.2 */

export const RETRY_DELAYS_MS = [
  0,
  2_000,
  30_000,
  5 * 60_000,
  30 * 60_000,
  2 * 60 * 60_000,
  12 * 60 * 60_000,
] as const;

export function nextRetryAt(attempt: number, now = Date.now()): number {
  const idx = Math.min(Math.max(attempt, 0), RETRY_DELAYS_MS.length - 1);
  const base = RETRY_DELAYS_MS[idx];
  // bounded jitter ±20%
  const jitter = base === 0 ? 0 : Math.floor(base * (0.8 + Math.random() * 0.4));
  return now + jitter;
}

export function shouldRetry(status: string, attempt: number): boolean {
  if (status === "backed_up" || status === "delivered" || status === "read") return false;
  if (status === "failed") return false;
  return attempt < RETRY_DELAYS_MS.length;
}
